import { getData, removeData, storeData } from "utilities/helper";

const TOKEN_KEY = "access_token";
const REFRESH_TOKEN_KEY = "refresh_token";
const IS_AUTHENTICATED_KEY = "is_authenticated";

const TokenService = {
  getToken() {
    return getData(TOKEN_KEY);
  },

  saveToken(accessToken: string) {
    storeData(TOKEN_KEY, accessToken);
  },

  removeToken() {
    removeData(TOKEN_KEY);
  },

  getRefreshToken() {
    return getData(REFRESH_TOKEN_KEY);
  },

  saveRefreshToken(refreshToken: string) {
    storeData(REFRESH_TOKEN_KEY, refreshToken);
  },

  removeRefreshToken() {
    removeData(REFRESH_TOKEN_KEY);
  },

  getIsAuthenticated() {
    return getData(IS_AUTHENTICATED_KEY);
  },

  saveIsAuthenticated(isAuthenticated: boolean) {
    storeData(IS_AUTHENTICATED_KEY, isAuthenticated);
  },

  removeIsAuthenticated() {
    removeData(IS_AUTHENTICATED_KEY);
  },
};

export default TokenService;
